module.exports = __webpack_public_path__ + "img/26_61.f6f48ecc.png";